export const TOKEN = 'access_token';
export const NEW_TOKEN = 'access';
export const REFRESH = 'refresh_token';
export const PREFIX = '@Samart';
